const SCREEN_SIZE = {
  "南宁交投智慧能源数字化管理平台": {
    width: 3840,  // 1920 * 2
    height: 2160 // 1080 * 2
  },
  "登录": {
    width: 3840,  // 1920 * 2
    height: 2160 // 1080 * 2
  },
  "智惠大屏AI":{
    width: 3840,  // 1920 * 2
    height: 2160 // 1080 * 2
  }
}

export default SCREEN_SIZE;
